import React from 'react';

import BaseClass from '../BaseClass';
import areaList from '@/utils/area';

import {httpPost, message, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'info': {},
            'addressInfo': {},
            'passwordInfo': {},

            'provinceList': [],
            'cityList': [],
            'areaList': [],

            'formValid': {
                'info': false,
                'address': false,
                'password': false,
            },
        };
    }

    componentDidMount() {
        this.initInfo();
        this.getAddressInfo();

        this.fileRef.addEventListener('change', (e) => {
            let file = e.target.files[0];
            let param = new FormData();
            param.append('file', file);

            let url = pcUrl('/personal/photo');
            httpPost(url, param, 'PUT')
                .then(data => {
                    message('用户头像更新成功');

                    //更新头像
                    this.props.updateUserInfo && this.props.updateUserInfo();
                });
        });

    }

    componentDidUpdate(nextProps) {
        if (
            nextProps.userInfo &&
            nextProps.userInfo.id != this.props.userInfo.id
        ) {
            let info = {
                'name': this.props.userInfo.name,
                'classes': this.props.userInfo.classes,
                'mobile': this.props.userInfo.mobile,
            };
            this.setState({
                info,
            }, () => {
                this.checkFormValid('info');
            });
        }
    }

    initInfo() {
        let info = {
            'name': this.props.userInfo.name,
            'classes': this.props.userInfo.classes,
            'mobile': this.props.userInfo.mobile,
        };
        this.setState({
            info,
        }, () => {
            this.checkFormValid('info');
        });
    }

    getInfo() {
        let url = pcUrl('/personal');

        httpPost(url, {}, 'get')
            .then(data => {
                this.setState({
                    'info': data,
                }, () => {
                    this.checkFormValid('info');
                });
            });
    }

    getAddressInfo() {
        let url = pcUrl('/personal/address');
        httpPost(url, {}, 'GET')
            .then(data => {
                if (data && data.id) {
                    let provinceList = this.getAreaList();
                    let addressInfo = data;

                    this.setState({
                        provinceList,
                        addressInfo,
                    }, () => {
                        this.checkFormValid('address');
                    });
                    this.provinceChange(addressInfo.province);
                } else {
                    let addressInfo = this.state.addressInfo;
                    let provinceList = this.getAreaList();
                    addressInfo.province = Object.keys(provinceList)[0];
                    this.setState({
                        provinceList,
                        addressInfo,
                    });
                    this.provinceChange(addressInfo.province);
                }
            });
    }

    checkFormValid(key) {
        if ('info' == key) {
            let result = this.validateInfo(this.state.info);
            let formValid = this.state.formValid;
            formValid[key] = result['flag'];
            this.setState({formValid});
        } else if ('address' == key) {
            let result = this.validateAddress(this.state.addressInfo);
            let formValid = this.state.formValid;
            formValid[key] = result['flag'];
            this.setState({formValid});
        } else if ('password' == key) {
            let result = this.validatePassword(this.state.passwordInfo);
            let formValid = this.state.formValid;
            formValid[key] = result['flag'];
            this.setState({formValid});
        }
    }

    submitInfo() {
        let url = pcUrl('/personal');
        let param = this.state.info;
        if (!param.classes)
            param.classes = this.props.userInfo.classes;
        if (!param.mobile)
            param.mobile = this.props.userInfo.mobile;

        let result = this.validateInfo(param);
        if (!result.flag) {
            message(result.message);
            this[result.ref].focus();
            return false;
        }

        httpPost(url, param, 'put')
            .then(() => {
                message('基础信息编辑成功', 'success');

                //更新
                this.props.updateUserInfo && this.props.updateUserInfo();
            });
    }

    validateInfo(param) {
        let result = {
            'flag': false,
            'message': '',
            'ref': '',
        };
        if (!param.classes) {
            result.message = '请填写班级';
            result.ref = 'classRef';
            return result;
        }
        if (!param.mobile) {
            result.message = '请填写家长电话';
            result.ref = 'mobileRef';
            return result;
        }
        let preg = /^1\d\d\d{8}$/;
        if (!param.mobile.match(preg)) {
            result.message = '请填写正确的手机号';
            result.ref = 'mobileRef';
            return result;
        }

        result['flag'] = true;
        return result;
    }

    submitAddress() {
        let url = pcUrl('/personal/address');
        let param = this.state.addressInfo;
        let result = this.validateAddress(param);
        if (!result.flag) {
            message(result.message);
            this[result.ref].focus();
            return false;
        }

        httpPost(url, param, 'PUT')
            .then(() => {
                message('地址保存成功', 'success');
            });
    }

    validateAddress(param) {
        let result = {
            'flag': false,
            'message': '',
            'ref': '',
        };
        if (!param.name) {
            result.message = '请输入收件人';
            result.ref = 'addressNameRef';
            return result;
        }
        if (!param.mobile) {
            result.message = '请输入收件人电话';
            result.ref = 'addressMobileRef';
            return result;
        }
        let preg = /^1\d\d\d{8}$/;
        if (!param.mobile.match(preg)) {
            result.message = '请填写正确的手机号';
            result.ref = 'addressMobileRef';
            return result;
        }
        if (!param.postCode) {
            result.message = '请填写邮政编码';
            result.ref = 'addressPostCodeRef';
            return result;
        }
        if (param.postCode.length > 6) {
            result.message = '请填写6位数的邮政编码';
            result.ref = 'addressPostCodeRef';
            return result;
        }
        if (!param.province) {
            result.message = '请选择所在省份';
            result.ref = 'addressPostCodeRef';
            return result;
        }
        if (!param.city) {
            result.message = '请选择所在城市';
            result.ref = 'addressCityRef';
            return result;
        }
        if (!param.area) {
            result.message = '请选择所在地区';
            result.ref = 'addressAreaRef';
            return result;
        }
        if (!param.address) {
            result.message = '请填写详细地址';
            result.ref = 'addressRef';
            return result;
        }
        result['flag'] = true;
        return result;
    }

    submitPassword() {
        let url = pcUrl('/personal/pwd');
        let param = this.state.passwordInfo;
        let result = this.validatePassword(param);
        if (!result.flag) {
            message(result.message);
            this[result.ref].focus();
            return false;
        }

        httpPost(url, param, 'PUT')
            .then(() => {
                message('密码修改成功，您需要重新登录', 'success');
                this.setState({
                    'passwordInfo': {
                        'oldPassword': '',
                        'newPassword': '',
                        'newPassword1': '',
                    },
                });
                this.props.history.replace('/login');
            });
    }

    validatePassword(param) {
        let result = {
            'flag': false,
            'message': '',
            'ref': '',
        };
        if (!param.oldPassword) {
            result.message = '请输入原密码';
            result.ref = 'oldPasswordRef';
            return result;
        }
        if (!param.newPassword) {
            result.message = '请输入新密码';
            result.ref = 'newPasswordRef';
            return result;
        }
        if (!param.newPassword1) {
            result.message = '请重复新密码';
            result.ref = 'newPassword1Ref';
            return result;
        }
        if (param.newPassword != param.newPassword1) {
            result.message = '两次密码输入不一致';
            result.ref = 'newPassword1Ref';
            return result;
        }

        result['flag'] = true;
        return result;
    }

    getAreaList(parentCode) {
        if (!parentCode)
            parentCode = 100000;

        return areaList[parentCode] || [];
    }

    provinceChange(province) {
        let cityList = this.getAreaList(province);
        let addressInfo = this.state.addressInfo;
        addressInfo.province = province;
        addressInfo.city = Object.keys(cityList)[0];

        this.setState({
            'cityList': cityList,
            'addressInfo': addressInfo,
        });

        this.cityChange(addressInfo.city);
    }

    cityChange(city) {
        let areaList = this.getAreaList(city);
        let addressInfo = this.state.addressInfo;
        addressInfo.city = city;
        addressInfo.area = Object.keys(areaList)[0];

        this.setState({
            'areaList': areaList,
            'addressInfo': addressInfo,
        });
        this.areaChange(addressInfo.area);
    }

    areaChange(area) {
        let addressInfo = this.state.addressInfo;
        addressInfo.area = area;

        this.setState({
            'addressInfo': addressInfo,
        });
    }

    render() {
        return (
            <>
                <div className="index-panel user-profile-panel">
                    <div className="captain">
                        <h3>
                            <span className="clips index-panel-grsz-ico"></span>
                            个人设置
                        </h3>
                    </div>
                    <div className="panel-body">
                        <div className="user-profile-left">
                            <div className="form">
                                <div className="form-captain">
                                    <h3>基础信息</h3>
                                </div>
                                <div className="form-li">
                                    <span className="label">姓名：</span>
                                    <span className="value"> {this.state.info.name} </span>
                                </div>
                                <div className="form-li">
                                    <span className="label">班级：</span>
                                    <input ref={e => this.classRef = e} name="classes" value={this.state.info.classes}
                                           onChange={(e) => this.bindModel(e).then(() => this.checkFormValid('info'))}
                                           className="input-text"/>
                                </div>
                                <div className="form-li">
                                    <span className="label">电话：</span>
                                    <input ref={e => this.mobileRef = e} name="mobile" value={this.state.info.mobile}
                                           onChange={(e) => this.bindModel(e).then(() => this.checkFormValid('info'))}
                                           className="input-text"/>
                                </div>
                                <div className="form-li just-end">
                                    <button
                                        className={['button', this.state.formValid.info ? 'button-blue' : 'button-gray'].join(' ')}
                                        onClick={() => {
                                            this.submitInfo()
                                        }}>保存更改
                                    </button>
                                </div>
                            </div>
                            {/*<div className="form">*/}
                            {/*    <div className="form-captain">*/}
                            {/*        <h3>*/}
                            {/*            家庭住址*/}
                            {/*            <span className="small">*/}

							{/*			</span>*/}
                            {/*        </h3>*/}
                            {/*    </div>*/}
                            {/*    <div className="form-li">*/}
                            {/*        <span className="label">收件人：</span>*/}
                            {/*        <input ref={e => this.addressNameRef = e} name="name"*/}
                            {/*               value={this.state.addressInfo.name}*/}
                            {/*               onChange={e => this.bindModel(e, 'addressInfo').then(() => this.checkFormValid('address'))}*/}
                            {/*               className="input-text" placeholder="请输入"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="row gutter-1">*/}
                            {/*        <div className="col col-6">*/}
                            {/*            <div className="form-li">*/}
                            {/*                <span className="label">电话：</span>*/}
                            {/*                <input ref={e => this.addressMobileRef = e} name="mobile"*/}
                            {/*                       value={this.state.addressInfo.mobile}*/}
                            {/*                       onChange={e => this.bindModel(e, 'addressInfo').then(() => this.checkFormValid('address'))}*/}
                            {/*                       className="input-text" placeholder="请输入"/>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*        <div className="col col-6">*/}
                            {/*            <div className="form-li">*/}
                            {/*                <span className="label">邮编：</span>*/}
                            {/*                <input ref={e => this.addressPostCodeRef = e} name="postCode"*/}
                            {/*                       value={this.state.addressInfo.postCode}*/}
                            {/*                       onChange={e => this.bindModel(e, 'addressInfo').then(() => this.checkFormValid('address'))}*/}
                            {/*                       className="input-text" placeholder="请输入"/>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    <div className="form-li">*/}
                            {/*        <span className="label">所在省市：</span>*/}
                            {/*        <div className="form-value">*/}
                            {/*            <div className="row gutter-2">*/}
                            {/*                <div className="col col-4">*/}
                            {/*                    <select ref={e => this.addressProvinceRef = e} name="province"*/}
                            {/*                            value={this.state.addressInfo.province} onChange={e => {*/}
                            {/*                        let code = e.target.value;*/}
                            {/*                        this.provinceChange(code);*/}
                            {/*                    }} className="input-text">*/}
                            {/*                        {Object.keys(this.state.provinceList).map((code) => (*/}
                            {/*                            <option value={code}>{this.state.provinceList[code]}</option>*/}
                            {/*                        ))}*/}
                            {/*                    </select>*/}
                            {/*                </div>*/}
                            {/*                <div className="col col-4">*/}
                            {/*                    <select ref={e => this.addressCityRef = e} name="city"*/}
                            {/*                            value={this.state.addressInfo.city} onChange={e => {*/}
                            {/*                        let code = e.target.value;*/}
                            {/*                        this.cityChange(code);*/}
                            {/*                    }} className="input-text">*/}
                            {/*                        {Object.keys(this.state.cityList).map((code) => (*/}
                            {/*                            <option value={code}>{this.state.cityList[code]}</option>*/}
                            {/*                        ))}*/}
                            {/*                    </select>*/}
                            {/*                </div>*/}
                            {/*                <div className="col col-4">*/}
                            {/*                    <select ref={e => this.addressAreaRef = e} name="area"*/}
                            {/*                            value={this.state.addressInfo.area} onChange={e => {*/}
                            {/*                        let code = e.target.value;*/}
                            {/*                        this.areaChange(code);*/}
                            {/*                    }} className="input-text">*/}
                            {/*                        {Object.keys(this.state.areaList).map((code) => (*/}
                            {/*                            <option value={code}>{this.state.areaList[code]}</option>*/}
                            {/*                        ))}*/}
                            {/*                    </select>*/}
                            {/*                </div>*/}
                            {/*            </div>*/}
                            {/*        </div>*/}
                            {/*    </div>*/}
                            {/*    <div className="form-li">*/}
                            {/*        <span className="label">详细地址：</span>*/}
                            {/*        <input ref={e => this.addressRef = e} name="address"*/}
                            {/*               value={this.state.addressInfo.address}*/}
                            {/*               onChange={e => this.bindModel(e, 'addressInfo').then(() => this.checkFormValid('address'))}*/}
                            {/*               className="input-text" placeholder="请输入"/>*/}
                            {/*    </div>*/}
                            {/*    <div className="form-li just-end">*/}
                            {/*        <button*/}
                            {/*            className={['button', this.state.formValid.address ? 'button-blue' : 'button-gray'].join(' ')}*/}
                            {/*            onClick={() => this.submitAddress()}>保存更改*/}
                            {/*        </button>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            <div className="form">
                                <div className="form-captain">
                                    <h3>
                                        安全设置
                                    </h3>
                                </div>
                                <div className="form-li">
                                    <span className="label">原密码：</span>
                                    <input ref={e => this.oldPasswordRef = e} type="password" name="oldPassword"
                                           value={this.state.passwordInfo.oldPassword}
                                           onChange={e => this.bindModel(e, 'passwordInfo').then(() => this.checkFormValid('password'))}
                                           className="input-text"/>
                                </div>
                                <div className="form-li">
                                    <span className="label">新密码：</span>
                                    <input ref={e => this.newPasswordRef = e} type="password" name="newPassword"
                                           value={this.state.passwordInfo.newPassword}
                                           onChange={e => this.bindModel(e, 'passwordInfo').then(() => this.checkFormValid('password'))}
                                           className="input-text"/>
                                </div>
                                <div className="form-li">
                                    <span className="label">重复密码：</span>
                                    <input ref={e => this.newPassword1Ref = e} type="password" name="newPassword1"
                                           value={this.state.passwordInfo.newPassword1}
                                           onChange={e => this.bindModel(e, 'passwordInfo').then(() => this.checkFormValid('password'))}
                                           className="input-text"/>
                                </div>
                                <div className="form-li just-end">
                                    <button
                                        className={['button', this.state.formValid.password ? 'button-blue' : 'button-gray'].join(' ')}
                                        onClick={() => this.submitPassword()}>保存更改
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="user-profile-right">
                            <div className="user-avatar">
                                <dl>
                                    <dt>
                                        <img src={this.props.userInfo.avatar || require('@/assets/images/avatar.png')}/>
                                    </dt>
                                    <dd>
                                        <button className="button button-border border-blue"
                                                onClick={() => this.fileRef.click()}>更换头像
                                        </button>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                        <div className="clear"></div>
                    </div>
                    <input ref={e => this.fileRef = e} type="file" style={{'display': 'none'}}/>
                </div>
            </>
        );
    }
}
